'use client'

import { config } from '@ensemble.music/ui'
import { useServerInsertedHTML } from 'next/navigation'
import type { ReactNode } from 'react'
import { StyleSheet } from 'react-native'
import { TamaguiProvider } from 'tamagui'

// Light only: the theme is set with defaultTheme on TamaguiProvider (the documented way - not a
// <Theme> wrapper), and the config has no dark theme, so nothing can switch away from it.
// useServerInsertedHTML hands the react-native-web stylesheet to Next during SSR.
export function NextTamaguiProvider({ children }: { children: ReactNode }) {
  useServerInsertedHTML(() => {
    const sheet = StyleSheet.getSheet()
    return (
      <style
        dangerouslySetInnerHTML={{ __html: sheet.textContent }}
        id={sheet.id}
      />
    )
  })

  return (
    <TamaguiProvider
      config={config}
      defaultTheme="light"
    >
      {children}
    </TamaguiProvider>
  )
}
